import {showNotification} from "@/actions";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {IconButton} from "@mui/material";
import {useDispatch} from "react-redux";
import {defineMessage} from "react-intl";

const RecordingIdCopier = ({recordingId}: {recordingId: string}) => {
    const dispatch = useDispatch();

    const copy = () => {
        navigator.clipboard.writeText(recordingId);
        dispatch(
            showNotification(
                defineMessage({id: "copied_to_clipboard", defaultMessage: "Copied to clipboard"}),
                "success",
            ),
        );
    };

    return (
        <div style={{display: "flex", alignItems: "center", flexDirection: "row", gap: 5}}>
            {recordingId}
            <IconButton onClick={copy}>
                <FontAwesomeIcon icon="copy" />
            </IconButton>
        </div>
    );
};

export default RecordingIdCopier;
